import { injectable } from 'inversify';
import { RPCImpl } from 'protobufjs';

@injectable()
abstract class RpcTransport {
  abstract getRpcImpl({ rpcUrl, headers }: { rpcUrl: string; headers?: { [key: string]: string } }): RPCImpl;
}

export { RpcTransport };
